var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"row\">\n<div class=\"col-sm-5 col-xs-12 text-right\" ng-transclude=\"label\"></div>\n<div class=\"col-sm-7 col-xs-12\">\n<strong ng-transclude=\"value\"></strong>\n</div>\n</div>\n";
var id1="app/secondary-trading/secondary-details-row.component.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;